export default "__VITE_ASSET__Dxfz7OK1__"